import React from 'react';
import styled from 'styled-components';
import { object } from 'prop-types';

import Link from 'ravenjs/lib/Link';

const LinkStyled = styled(Link)`
    overflow-wrap: break-word;
`;

function Email({ row }) {
    return (
        <LinkStyled
            gutter={false}
            fontFamily="RobotoMono"
            fontSize="0.875rem"
            target="_blank"
            href={`mailto:${row.email}`}
        >
            {row.email || '-'}
        </LinkStyled>
    );
}

Email.propTypes = {
    row: object,
};

Email.defaultProps = {
    row: {},
};

export default Email;
